export const options = {
  strings: [
    'Hey, If you need to find something just search and it will filter it',
    'Or Leave it Blank to Return your Favorite Banks',
    "Let's Go!",
    'Search for your favorite bank',
    '',
  ],
  bindInputFocusEvents: true,
  attr: 'placeholder',
  typeSpeed: 25,
  backSpeed: 25,
  cursorChar: '_',
  startDelay: 1150,
  smartBackspace: true,
  showCursor: true,
};
